import { render } from "./Inicio.vue?vue&type=template&id=6206b276&ts=true"
import script from "./Inicio.vue?vue&type=script&lang=ts"
export * from "./Inicio.vue?vue&type=script&lang=ts"

import "./Inicio.vue?vue&type=style&index=0&id=6206b276&lang=css"

import exportComponent from "/dados/apps/pdcrm/app_atual/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__